import { type NshiftIssueTokenResponse } from 'ecosystem'
import { apiCall } from '../utils/fetching'
import { NSHIFT_CLIENT_ID, NSHIFT_CLIENT_SECRET } from './constants'

/**
 * Fetches an access token from nShift using client credentials.
 */
export const nshiftIssueAccessToken = async (): Promise<NshiftIssueTokenResponse> => {
  if (!NSHIFT_CLIENT_ID) {
    throw new Error('NSHIFT_CLIENT_ID is not provided')
  }

  if (!NSHIFT_CLIENT_SECRET) {
    throw new Error('NSHIFT_CLIENT_SECRET is not provided')
  }

  const url = 'https://account.nshiftportal.com/idp/connect/token'
  const body = new URLSearchParams({
    client_id: NSHIFT_CLIENT_ID,
    client_secret: NSHIFT_CLIENT_SECRET,
    grant_type: 'client_credentials'
  })

  const { data, error, response } = await apiCall<NshiftIssueTokenResponse | { error: string }>(
    url,
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
        'Cache-Control': 'no-cache'
      },
      body: body.toString()
    }
  )

  if (error) {
    throw new Error(error)
  }

  if (!response?.ok) {
    throw new Error(data && 'error' in data ? data.error : 'Unknown error')
  }

  return data as NshiftIssueTokenResponse
}

export const createNshiftAccessHeaders = async () => {
  const { access_token: accessToken, token_type: tokenType } = await nshiftIssueAccessToken()

  return {
    Authorization: `${tokenType} ${accessToken}`
  }
}
